// extracted by mini-css-extract-plugin
export default {"cardContainer":"Dashboard_cardContainer__P7JRU","listContainer":"Dashboard_listContainer__8AltV"};